import React from 'react';
import s from './style.module.css';
import { URL } from '@Pages/url';
import PhoneSVGIcon from '@Components/svg_icon/phone';
import OperatorSVGIcon from '@Components/svg_icon/operator';

const FooterInquiry = () => {
    return (
        <div className={s.footer_inquiry_outer}>
            <div className={s.footer_inquiry}>
                <p className={s.footer_inquiry_title_bar}>まずはお気軽にお問合せください</p>
                <div className={s.footer_inquiry_box}>
                    <div className={s.inquiry_left}>
                        <p>電話でお問合せ</p>
                        <a href={'tel:0120-18-0072'}>
                            <PhoneSVGIcon className={s.phone_icon} /> 0120-18-0072
                        </a>
                    </div>
                    <div className={s.border} />
                    <div className={s.inquiry_right}>
                        <a className={s.inquiry_button} href={URL.CONTACT}>
                            <OperatorSVGIcon />
                            WEBでお問合せ
                        </a>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default FooterInquiry;
